module.exports = __webpack_public_path__ + "img/naviki-mob.4efda731.png";